import { createContext, useContext, useState } from "react";

const GuideContext = createContext({
    startGuide: () => {},
    setGuideHandler: () => {}
});

export const GuideProvider = ({ children }) => {
    const [guideHandler, setGuideHandler] = useState(null);

    const startGuide = () => {
        if (guideHandler) {
            guideHandler();
        }
    };

    return (
        <GuideContext.Provider value={{ startGuide, setGuideHandler }}>
            {children}
        </GuideContext.Provider>
    );
};

export const useGuide = () => useContext(GuideContext);
